import React, { useState, useEffect } from 'react';
import {
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  Divider,
  InputLabel,
  FormControl,
  Select
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { getRol } from '../../../_utils/storage_handler';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Checkbox } from 'antd';
import {
  findOrdersEvent
} from '../../../_events/orders/find_order.event';

import { createProductWeightEvent, editProductWeightEvent } from '../../../_events/product_weight/product_weight.event';
import { getLiterFormula, validateLiterFormula } from '../../../_events/orderDetail/orderDetail.input';
import { literformulaEvent } from '../../../_events/orderDetail/orderDetail.event';
import { findColorantsEvent,createColorantEvent, deleteColorantEvent,updateColorantEvent } from '../../../_events/colorant/colorant.event';
import { aproverOrdersEvent, deleteOrdersEvent, displayPDFOrderEvent, consultFormulaEvent, processFormulaEvent } from '../../../_events/orders/order_box.event';
import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import ValidationBoxList from './validation_list';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';

import {
  buildFormulaBoxBody,
  validateFormulaBody,
  buildColoranBoxBody,
  validateColorantBoxBody,
  buildEditColoranBody
  
} from '../../../_events/customer_formula/customer_formula.input';

import {
  buildProductWeightBoxBody,
  validateProductWeightBody
} from '../../../_events/product_weight/product_weight.input';
import { isNotViewer } from '../../../_utils/render_actions';
import { findProductWeightById } from '../../../_services/product_weight.service';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: 800,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  transform: 'translate(-50%, -50%)',
};


const ValidationBox = () => {

  const in_process = 'WAIT';
  const [allChecked, setAllChecked] = useState(false);
  const [order, setOrder] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [pdf, setPDF] = React.useState(null);
  const [process_state, setProcess_state] = useState([]);
  const [orderDetail, setOrderDetail] = useState(false);
  const [formula, setFormula] = useState([]);
  const [colorants, setColorants] = useState([]);
  const [createButton, setCreateButton] = useState(false);
  const [openModaColorants, setOpenModaColorants] = React.useState(false);
  const [openModalWeight, setOpenModalWeight] = React.useState(false);
  
  const [data_formula, setData_formula] = useState([]);
  const [customer_formulas, setCustomer_formulas] = useState([]);
  const [openModalProductWeightEdit, setOpenModalProductWeightEdit] = React.useState(false);
  const [openModalProductWeight, setOpenModalProductWeight] = React.useState(false);
  const [openModalEditColorant, setOpenModalEditColorant] = React.useState(false);
  const [colorant, setColorant] = useState([]);
  const [weight, setWeight] = useState(null);
  const handleOpen = () => {
    setOpen(true);
  };


  const createColorant = (cod_colorant , name) => {
    createColorantEvent(cod_colorant , name)
    .then(data => {
      if(data.data)
      {
        message.error(data.data);
      }else{
        setOpenModaColorants(false);
        setColorants(data.list);
        message.success('Colorante creado');
      }
      
    })
  };

  const handleCloseModalColorant = () => {
    setOpenModaColorants(false);
    setColorants([]);
  };


  
  const findColorants = () => {
    findColorantsEvent()
    .then(data => {
      setColorants(data.list);
    })
  };

  const deleteColorant = (colorant) => {
    deleteColorantEvent(colorant)
      .then(data => {
       setColorants([]);
       setOpenModaColorants(false);
      
       message.success('Colorante eliminado');
      })
  };

  const setUpdateColorant = (colorant) => {
    setOpenModalEditColorant(true);
    setColorant(colorant);
  };

  const updateColorant = (colorant) => {
    updateColorantEvent(colorant)
    .then(data => {
      setColorant([]);
      setColorants([]);
      setOpenModalEditColorant(false);
      setOpenModaColorants(false);
     
      message.success('Colorante actualizado');
    })
    .catch(err => {
      message.error(err.message);
      setLoading(false);
    });
  };

  const createProductWeight = (body) => {
    const gramo_conver_kilo=Number(body.kilo)/1000;
    createProductWeightEvent(orderDetail.productPrice.product.uuid, gramo_conver_kilo, body.meter)
      .then(data => {
        loadData();
        message.success('Conversion registrada.')
      })
      .catch(err => {
        message.error(err.message);
      });
  };

  const editProductWeight = (w) => {
    let wSaved = {...w};
    wSaved.kilo = Number(wSaved.kilo)/1000;
    editProductWeightEvent(wSaved)
    .then(data => {
        loadData();
        message.success('Conversion registrada.');
        closeEditWeight();
    })
    .catch(err => {
      message.error(err.message);
    });

  };

  const handleClose = () => {
    setOpen(false);
    setCreateButton(false);
    setFormula(null);
    setOpenModalWeight(false);
    setData_formula();
    setOpenModalProductWeight(false);
    setColorants(null);
  };

  const handleClosePDF = () => {
    setOpenPDF(false);
  };

  const loadData = () => {
    findOrdersEvent('WAIT')
    .then(data => {
      let orders_list = [];
      let process_list = [];
      let customer_formulas = [];
      data.list.forEach(obj => {
        if (obj.uuid != null && obj.id) {
          orders_list.push(obj);
        } else if (obj.name != null && obj.cod ==='MARC' || obj.cod === 'ENRO'|| obj.cod === 'DEFE' || obj.cod === 'CRUD' ) {
          process_list.push(obj);
        } else if (obj.machine != null) {
          customer_formulas.push(obj);
        }
      });
      setOrders(orders_list);
      process_list.sort((a, b) => (a.cod === 'DEFE') ? -1 : ((b.cod === 'DEFE') ? 1 : 0));
      setProcess_state(process_list);
      setCustomer_formulas(customer_formulas);
      setLoading(false);
    })
    .catch(err => {
      message.error(err.message);
      setLoading(false);
    });
  }

  const loadOrders = () => {
    setAllChecked(false);
    setLoading(true);
    loadData();
  }
  const setEditOrder = (o, p) => {
    setOrder({ uuid: p.uuid, order: o });
    setOrderDetail(o);
    setOrder(p);
    cosult_formula(o);
  }

  const setliterFormula = (od) => {
    setOrderDetail(od);
    setOpenModalWeight(true);
  }

  const consultColorants = () => {
    setOpenModaColorants(true);
  }

  const aprove = () => {
    let selectedOptions = [];
    orders.forEach((order) => {
      let count = 0;
      order.ordersDetail.forEach((orderDetail) => {
        const selectElement = document.querySelector(`select[data-uuid="${orderDetail.uuid}"]`);
        if (selectElement) {
          selectedOptions.push(selectElement.value);
        } else {
          count = 1;
        }
      });
      if (count > 0) {
        selectedOptions.push(`all-defect-i//${order.uuid}`);
        count = 0;
      }
    });
    aproverOrdersEvent(orders, selectedOptions, in_process)
      .then(data => {
        if (data.data) {
          message.warning(data.data);
        } else {
          message.success('Productos aprobados.');
        }
        //downloadExcelFile(data.data.toAproveJSON,"ordenes");
        loadOrders();
      })
      .catch(err => {
        message.error(err.message);
      });
  };


  const deleteOrder = (order) => {
    deleteOrdersEvent(order.uuid)
      .then(data => {
        message.success('Orden eliminada');
        loadOrders();
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  const checkAll = () => {
    let check = allChecked;
    let ordersNew = [...orders];
    ordersNew.forEach(element => {
      element.checked = check ? 0 : 1;
    });
    setAllChecked(!check);
    setOrders(ordersNew);
  }

  const displayPDF = (order) => {
    if (!order) message.error('No hay orden');
    else {
      let o = Object.assign({}, order);
      displayPDFOrderEvent(o)
        .then(data => {
          setPDF(data.data.toAproveJSON);
          setOpenPDF(true);
        })
        .catch(err => {
          message.error(err.message);
        });
    }
  }

  const cosult_formula = (orderDetail) => {
    consultFormulaEvent(orderDetail)
      .then(data => {
        setFormula(data.data.formula);
        if (data.data.formula === null) {
          setCreateButton(true);
        }
        setColorants(data.data.colorants);
        handleOpen();
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  const openEditWeight = (uuid, type) => {
    findProductWeightById(uuid)
      .then(data => {
        let json = data.data;
        if(type === 'MTS')
        json.kilo = json.kilo*1000;
        setWeight(json);
        setOpenModalProductWeightEdit(true);
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  const closeEditWeight = () => {
      setWeight(null);
      setOpenModalProductWeightEdit(false);
  }

  const setLiterformula = (literFormula) => {
    literformulaEvent(literFormula, orderDetail)
      .then(data => {
        handleClose();
        loadData();
        if (data.ok) {
          message.success('Litros de formula guardados');
        } else {
          message.error('Algo salio mal, intentalo de nuevo');
        }

      })
      .catch(err => {
        message.error(err.message);
      });
  }

  const process_formula = (data_formula) => {
    processFormulaEvent(orderDetail, data_formula)
      .then(data => {
        handleClose();
        message.success(data.data);
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  useEffect(() => {
    loadOrders();
  }, []);

  let rol = getRol();



  return (
    <Grid container spacing={1} >
      <Grid item xs={12} md={12}>
        <Typography variant="h6" component="h6">
          Bandeja de Validacion
        </Typography>
        <hr />
        {
          loading ? (
            <PrimaryProgress />
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={6} md={6}>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                  <Chip label={`Total: ${orders.length}`} color="primary" variant="outlined" />
                  <Chip label={`Entregas INMEDIATAS: ${orders.filter(o => o.date_delivery === null).length}`} color="error" variant="outlined" />
                  <Chip label={`Seleccionadas: ${orders.filter(o => o.checked === 1).length}`} color="success" variant="outlined" />
                </div>
              </Grid>
              <Grid item xs={6} md={6}>
                <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '100%' }}>
                  <div style={{ marginLeft: '20px' }}>
                  <BasicPopconfirm
                    label='Aprobar órdenes'
                    title='¿Desea abrir los colorantes?'
                    onConfirm={() => { isNotViewer(rol) ? aprove() : alert('Usuario informativo') }}
                  />
                  </div>
                  <div style={{ marginLeft: '20px' }}>
                    <BasicPopconfirm
                      label='Colorantes'
                      title='¿Desea consultar los colorantes?'
                      onConfirm={() => { isNotViewer(rol) ? consultColorants() : alert('Usuario informativo') }}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} md={12}>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
                  <Checkbox
                    style={{ marginRight: '55px' }}
                    checked={allChecked}
                    onClick={event => {
                      event.stopPropagation();
                    }}
                    onChange={() => {
                      checkAll();
                    }}>
                  </Checkbox>
                </div>
              </Grid>
              <Grid item xs={12} md={12}>
                <ValidationBoxList
                  openEditWeight={openEditWeight}
                  data={orders}
                  process={process_state}
                  customer_formulas={customer_formulas}
                  setOpenModalProductWeight={setOpenModalProductWeight}
                  setEditOrder={(o, p) => setEditOrder(o, p)}
                  setOrderDetail={setOrderDetail}
                  setliterFormula={(od) => setliterFormula(od)}
                  updateDataOrdersChecked={(d) => {
                    let index = orders.findIndex(o => o.uuid === d.uuid);
                    if (index === -1) {
                      message.error('No se logró seleccionar');
                    } else {
                      let orders_updated = [...orders];
                      orders_updated[index].checked = orders_updated[index].checked === 0 ? 1 : 0;
                      setOrders(orders_updated);
                    }
                  }}
                  deleteOrder={(o) => { isNotViewer(rol) ? deleteOrder(o) : alert('Usuario informativo') }}
                  displayPDF={(o) => displayPDF(o)}
                />
              </Grid>
            </Grid>
          )
        }
      </Grid>

      {/* modal para crear una formula */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container justifyContent="center">
            <Typography variant="h6" align="center">
              Información general
            </Typography>
          </Grid>
          <Grid container spacing={2}>

            <Grid item xs={12} md={6}>
            </Grid>
            <Grid item xs={12} md={6}>

            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                id="cod_cliente"
                label="Codigo del cliente"
                variant="outlined"
                size="small"
                defaultValue={orderDetail ? orderDetail.productPrice.client.cod : ''}
                disabled

              />
            </Grid>

            <Grid item xs={12} md={6}>

              <TextField
                fullWidth
                required
                label="Ref. producto"
                variant="outlined"
                id="ref_product"
                size="small"
                defaultValue={orderDetail ? orderDetail.productPrice.product.ref : ''}
                disabled
              />

            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                id="cod_color"
                label="Codigo color"
                variant="outlined"
                size="small"
                defaultValue={orderDetail ? orderDetail.color.cod : ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                id="machine_formula"
                label="Maquina"
                variant="outlined"
                size="small"
                defaultValue={formula ? formula.machine : ''}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                id="name_color"
                label="Nombre del color"
                variant="outlined"
                size="small"
                defaultValue={orderDetail ? orderDetail.color.description : ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                id="observation_formula"
                label="Observacion de formula"
                variant="outlined"
                size="small"
                defaultValue={formula ? formula.formula_detail : ''}
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="select-1">Select 1</InputLabel>
                    <Select
                      native
                      label="Select 1"
                      inputProps={{
                        name: 'select-1',
                        id: 'select-1',
                      }}
                    >
                      {formula && formula.color_1 && colorants ? (
                        <option value={formula.color_1}>
                          {colorants.find((colorant) => colorant.cod_colorant === formula.color_1)?.name || 'Seleccionar'}
                        </option>
                      ) : null}
                      {colorants &&
                        colorants.length > 0 &&
                        [
                          ...colorants
                            .filter((colorant) => !(formula && formula.color_1 === colorant.cod_colorant))
                            .map((colorant) => (
                              <option key={colorant.cod_colorant} value={colorant.cod_colorant}>
                                {colorant.name}
                              </option>
                            )),
                        ]
                      }
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    label="Cant. colorante 1"
                    variant="outlined"
                    size="small"
                    id="quantity_1"
                    type="number"
                    inputProps={{ step: 0.01 }}
                    defaultValue={formula ? formula.quantity_1 : ''}
                  />
                </TableCell>
                <TableCell>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="select-2">Select 2</InputLabel>
                    <Select
                      native
                      label="Select 2"
                      inputProps={{
                        name: 'select-2',
                        id: 'select-2',
                      }}
                    >
                      {formula && formula.color_2 && colorants ? (
                        <option value={formula.color_2}>
                          {colorants.find((colorant) => colorant.cod_colorant === formula.color_2)?.name || 'Seleccionar'}
                        </option>
                      ) : null}
                      {colorants &&
                        colorants.length > 0 &&
                        [
                          ...colorants
                            .filter((colorant) => !(formula && formula.color_2 === colorant.cod_colorant))
                            .map((colorant) => (
                              <option key={colorant.cod_colorant} value={colorant.cod_colorant}>
                                {colorant.name}
                              </option>
                            )),
                        ]
                      }
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    label="Cant. colorante 2"
                    variant="outlined"
                    size="small"
                    id="quantity_2"
                    type="number"
                    inputProps={{ step: 0.01 }}
                    defaultValue={formula ? formula.quantity_2 : ''}
                  />
                </TableCell>

              </TableRow>
              <TableRow>
                <TableCell>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="select-3">Select 3</InputLabel>
                    <Select
                      native
                      label="Select 3"
                      inputProps={{
                        name: 'select-3',
                        id: 'select-3',
                      }}
                    >
                      {formula && formula.color_3 && colorants ? (
                        <option value={formula.color_3}>
                          {colorants.find((colorant) => colorant.cod_colorant === formula.color_3)?.name || 'Seleccionar'}
                        </option>
                      ) : null}
                      {colorants &&
                        colorants.length > 0 &&
                        [
                          ...colorants
                            .filter((colorant) => !(formula && formula.color_3 === colorant.cod_colorant))
                            .map((colorant) => (
                              <option key={colorant.cod_colorant} value={colorant.cod_colorant}>
                                {colorant.name}
                              </option>
                            )),
                        ]
                      }
                    </Select>

                  </FormControl>
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    label="Cant. colorante 3"
                    variant="outlined"
                    size="small"
                    id="quantity_3"
                    type="number"
                    inputProps={{ step: 0.01 }}
                    defaultValue={formula ? formula.quantity_3 : ''}
                  />
                </TableCell>

                <TableCell>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="select-4">Select 4</InputLabel>
                    <Select
                      native
                      label="Select 4"
                      inputProps={{
                        name: 'select-4',
                        id: 'select-4',
                      }}
                    >
                      {formula && formula.color_4 && colorants ? (
                        <option value={formula.color_4}>
                          {colorants.find((colorant) => colorant.cod_colorant === formula.color_4)?.name || 'Seleccionar'}
                        </option>
                      ) : null}
                      {colorants &&
                        colorants.length > 0 &&
                        [
                          ...colorants
                            .filter((colorant) => !(formula && formula.color_4 === colorant.cod_colorant))
                            .map((colorant) => (
                              <option key={colorant.cod_colorant} value={colorant.cod_colorant}>
                                {colorant.name}
                              </option>
                            )),
                        ]
                      }
                    </Select>

                  </FormControl>
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    label="Cant. colorante 4"
                    variant="outlined"
                    size="small"
                    id="quantity_4"
                    type="number"
                    inputProps={{ step: 0.01 }}
                    defaultValue={formula ? formula.quantity_4 : ''}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="select-5">Select 5</InputLabel>
                    <Select
                      native
                      label="Select 5"
                      inputProps={{
                        name: 'select-5',
                        id: 'select-5',
                      }}
                    >
                      {formula && formula.color_5 && colorants ? (
                        <option value={formula.color_5}>
                          {colorants.find((colorant) => colorant.cod_colorant === formula.color_5)?.name || 'Seleccionar'}
                        </option>
                      ) : null}
                      {colorants &&
                        colorants.length > 0 &&
                        [
                          ...colorants
                            .filter((colorant) => !(formula && formula.color_5 === colorant.cod_colorant))
                            .map((colorant) => (
                              <option key={colorant.cod_colorant} value={colorant.cod_colorant}>
                                {colorant.name}
                              </option>
                            )),
                        ]
                      }
                    </Select>

                  </FormControl>
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    id="quantity_5"
                    label="Cant. colorante 5"
                    variant="outlined"
                    size="small"
                    type="number"
                    inputProps={{ step: 0.01 }}
                    defaultValue={formula ? formula.quantity_5 : ''}
                  />
                </TableCell>

                <TableCell>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="select-6">Select 6</InputLabel>
                    <Select
                      native
                      label="Select 6"
                      inputProps={{
                        name: 'select-6',
                        id: 'select-6',
                      }}
                    >
                      {formula && formula.color_6 && colorants ? (
                        <option value={formula.color_6}>
                          {colorants.find((colorant) => colorant.cod_colorant === formula.color_6)?.name || 'Seleccionar'}
                        </option>
                      ) : null}
                      {colorants &&
                        colorants.length > 0 &&
                        [
                          ...colorants
                            .filter((colorant) => !(formula && formula.color_6 === colorant.cod_colorant))
                            .map((colorant) => (
                              <option key={colorant.cod_colorant} value={colorant.cod_colorant}>
                                {colorant.name}
                              </option>
                            )),
                        ]
                      }
                    </Select>

                  </FormControl>
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    label="Cant. colorante 6"
                    id="quantity_6"
                    variant="outlined"
                    size="small"
                    type="number"
                    inputProps={{ step: 0.01 }}
                    defaultValue={formula ? formula.quantity_6 : ''}
                  />
                  <TextField
                    fullWidth
                    label="Cant. colorante 6"
                    id="formula_id"
                    variant="outlined"
                    size="small"
                    type="number"
                    inputProps={{ step: 0.01 }}
                    defaultValue={formula ? formula.id : ''}
                    style={{ display: 'none' }}
                  />

                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <br />
          <Grid item xs={12} md={12}>
            {createButton ? (
              <Button size='small' variant='contained' onClick={() => {
                try {
                  let body = buildFormulaBoxBody();
                  validateFormulaBody(body);
                  setData_formula(body);
                  process_formula(body);
                } catch (err) {
                  message.error(err.message);
                }

              }}>Crear formula</Button>
            ) : (
              <Button size='small' variant='contained' onClick={() => {
                try {
                  let body = buildFormulaBoxBody();
                  validateFormulaBody(body);
                  setData_formula(body);
                  process_formula(body);
                } catch (err) {
                  message.error(err.message);
                }

              }}>Actualizar formula</Button>
            )}
          </Grid>
        </Box>
      </Modal>

      {/* modal para crear la conversion de peso */}
      <Modal
        open={openModalProductWeight}
        onClose={() => setOpenModalProductWeight(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="" component="">
            <div style={{ textAlign: 'center' }}>
              <p><b>! Registro de conversión !</b></p>
            </div>

            <p>Por favor introduzca la conversión</p>
          </Typography>
          <TextField
            label="Gramo(s)"
            variant="outlined"
            type="number"
            id="kilo"
            fullWidth
            required
            inputProps={{ step: 0.01 }}
          />
          <br /><br />
          <TextField
            label="Metro(s)"
            variant="outlined"
            type="number"
            id="meter"
            fullWidth
            required
            inputProps={{ step: 0.01 }}
          />


          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                try {
                  let body = buildProductWeightBoxBody();
                  validateProductWeightBody(body);
                  setOpenModalProductWeight(false);
                  createProductWeight(body);

                } catch (err) {
                  message.error(err.message);
                }

              }}
            >
              Registrar
            </Button>
          </div>
        </Box>
      </Modal>

      {/* modal para actualizar la conversion de peso */}
      <Modal
        open={openModalProductWeightEdit}
        onClose={closeEditWeight}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="" component="">
            <div style={{ textAlign: 'center' }}>
              <p><b>! Actualizar conversión !</b></p>
            </div>
          </Typography>
          <TextField
            label="Gramo(s)"
            variant="outlined"
            type="number"
            id="kilo"
            fullWidth
            required
            inputProps={{ step: 0.01 }}
            value={weight?.kilo}
            onChange={(e) => {
              let newW = {...weight};
              newW.kilo = e.target.value;
              setWeight(newW);
            }}
          />
          <br /><br />
          <TextField
            label="Metro(s)"
            variant="outlined"
            type="number"
            id="meter"
            fullWidth
            required
            inputProps={{ step: 0.01 }}
            value={weight?.meter}
            onChange={(e) => {
              let newW = {...weight};
              newW.meter = e.target.value;
              setWeight(newW);
            }}
          />


          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                try {
                  validateProductWeightBody(weight);
                  editProductWeight(weight);

                } catch (err) {
                  message.error(err.message);
                }

              }}
            >
              Actualizar
            </Button>
          </div>
        </Box>
      </Modal>

      {/* modal para asignar la formula a un tiṕo de medida */}
      <Modal
        open={openModalWeight}
        onClose={() => setOpenModalWeight(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="" component="">

            <div style={{ textAlign: 'center' }}>
              <p><b>Introduzca los litros necesarios</b></p>

              <p><b>{orderDetail ? orderDetail.literformula ? 'litros actuales: ' + orderDetail.literformula : '' : ''}</b></p>
            </div>
            {
              <div>
                {orderDetail.type_quantity ?
                  `cuantos litros se necesitan para ${orderDetail.quantity} ${orderDetail.type_quantity} de la referencia: ${orderDetail.productPrice.product.ref} `
                  :

                  null
                }
                <br /><br />
                <TextField
                  label="Litro(s)"
                  variant="outlined"
                  type="number"
                  id="literFormula"
                  fullWidth
                  required
                  inputProps={{ step: 0.01 }}
                />
              </div>
            }


          </Typography>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                try {
                  let body = getLiterFormula();
                  validateLiterFormula(body);
                  setLiterformula(body)
                } catch (err) {
                  message.error(err.message);
                }

              }}
            >
              Continuar
            </Button>
          </div>
        </Box>
      </Modal>

      {/* modal para ver los pdfs */}
      <Modal
        open={openPDF}
        onClose={handleClosePDF}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container spacing={1}>
            {
              !pdf ? <>Cargando...</> :
                <Grid item xs={12} md={12}>
                  <object width="100%" height="600px"
                    data={`data:application/pdf;base64,${pdf}`}
                    type="application/pdf" className="internal"
                  >
                    <embed
                      src={`data:application/pdf;base64,${pdf}`}
                      type="application/pdf"
                    />
                  </object>
                </Grid>
            }
          </Grid>
        </Box>
      </Modal>

      {/** Colorantes */}
      <Modal
        open={openModaColorants}
        onClose={() => {handleCloseModalColorant()
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <div style={{ marginLeft: '20px' }}>
              <TextField
                label="Cod. colorante"
                variant="outlined"
                type="text"
                id="cod_colorant"
                fullWidth
                required
                inputProps={{
                  maxLength: 4,
                }}
              />
            </div>
            <div style={{ marginLeft: '20px' }}>
              <TextField
                label="Nom. colorante"
                variant="outlined"
                type="text"
                id="nom_colorant"
                fullWidth
                required
                inputProps={{
                  maxLength: 30,
                }}
              />
            </div>
            <div style={{ marginLeft: '20px' }}>
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  try {
                    findColorants();
                  } catch (err) {
                    message.error(err.message);
                  }
                }}
              >
                Cargar
              </Button>
            </div>
            <div style={{ marginLeft: '20px' }}>
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  try {
                    const body = buildColoranBoxBody();
                    validateColorantBoxBody(body);
                    createColorant(body.cod_colorant, body.name);
                  } catch (err) {
                    message.error(err.message);
                  }
                }}
              >
                Crear
              </Button>
            </div>
          </div>
          <div style={{ overflow: 'auto', maxHeight: '300px' }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Código Colorante</TableCell>
                    <TableCell>Nombre Colorante</TableCell>
                    <TableCell>Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {colorants? colorants.map((colorant, index) => (
                    <TableRow key={index}>
                      <TableCell>{colorant.cod_colorant}</TableCell>
                      <TableCell>{colorant.name}</TableCell>
                      <TableCell>
                        <IconButton color="error" aria-label="Eliminar"  onClick={() => { deleteColorant(colorant); }}>
                          <DeleteIcon />
                        </IconButton>
                        <IconButton aria-label="Actualizar"  onClick={() => {setUpdateColorant(colorant);}}>
                          <RefreshIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                :
                null}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Box>
      </Modal>



      <Modal
        open={openModalEditColorant}
        onClose={() => {
          setOpenModalEditColorant(false);
          setColorant([]);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <div style={{ marginLeft: '20px' }}>
              <TextField
                label="Cod. colorante"
                variant="outlined"
                type="text"
                id="cod"
                fullWidth
                required
                disabled={true}
                defaultValue={colorant.cod_colorant? colorant.cod_colorant:null }
                
                inputProps={{
                  maxLength: 4,
                }}
              />
            </div>
            <div style={{ marginLeft: '20px' }}>
              <TextField
                label="Nom. colorante"
                variant="outlined"
                type="text"
                id="name"
                fullWidth
                required
                defaultValue={colorant.name? colorant.name:'' }
                inputProps={{
                  maxLength: 30,
                }}
              />
            </div>
            
            <div style={{ marginLeft: '20px' }}>
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  try {
                    const body = buildEditColoranBody();
                    validateColorantBoxBody(body);
                    updateColorant(body);
                  } catch (err) {
                    message.error(err.message);
                  }
                }}
              >
                Actualizar
              </Button>
            </div>
          </div>
          
        </Box>
      </Modal>



    </Grid>
  );
}

export default ValidationBox;
